import _ from 'lodash'
import GenericOverviewInfoDisplayHeader from 'scoreboard/components/overview-info/generic-overview-info-display-header'
import SendToOptions from 'scoreboard/components/send-to-options'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'
import chartsTabsTemplate from './charts-tabs.hbs'
import { isV6 } from 'scoreboard/components/version'

const ChartsDisplayHeader = GenericOverviewInfoDisplayHeader.extend({
	initialize: function(options) {
		GenericOverviewInfoDisplayHeader.prototype.initialize.apply(this, arguments)

		// show or hide the period selector whenever a feature or breakdown changes
		_.forEach([this.model.chartDesigner.features, this.model.chartDesigner.breakdowns], coll => {
			this.listenTo(coll, 'change add remove', () => {
				this.togglePeriodDisplay(this.model.chartDesigner.showPeriodSelector())
			})
		})
	},

	_renderPeriodDisplay: function() {
		GenericOverviewInfoDisplayHeader.prototype._renderPeriodDisplay.apply(this, arguments)
		this.togglePeriodDisplay(_.invoke(this.model.chartDesigner, 'showPeriodSelector'))	//initial display
	},

	redrawDisplay: function(newPeriodId) {
		this.trigger('change:period', newPeriodId)
	},

	styleAlertButton: function(hasAlerts) {
		GenericOverviewInfoDisplayHeader.prototype.styleAlertButton.apply(this, arguments)
		if (this.alertButton) {
			this.alertButton.find('.icon-menu').hide()
			this.alertButton
				.toggleClass('is-not-displayed', false)
		}
	}
})


const chartsHeader = {

	headerText: function(model) {
		return model.isNew() ?
			i18n.get('common.create2', metadata[model.section].createTypeCode) :
			model.get('label')
	},

	generate: function(subsection, model, resultsView) {

		// invoked by send-to-export.js
		const uiState = options => _.invoke(resultsView, 'getState', options)

		const sendToOptions = [].concat(
			SendToOptions.briefing({ uiState }),
			SendToOptions.exportServerOptions({ uiState }))

		return new ChartsDisplayHeader({
			heading: chartsHeader.headerText(model),
			model,
			section: 'charts',
			subsection,
			sendToOptions: subsection === 'edit' ? null : sendToOptions,
			tabs: model.isNew() && isV6() ? '' :
				chartsTabsTemplate(model.toJSON()),
			periods: true,
			// Note that according to DisplayHeader.initialize(), the 'guard' option
			// only determines whether the guard is applied when changing periods.
			guard: false,
			uiState: () => resultsView.getState()
		})
	}
}

export default chartsHeader

chartsHeader.__filename__ = 'charts/charts-header.js'
